import { render, staticRenderFns } from "./TakeFood.vue?vue&type=template&id=05faf49d&scoped=true&"
import script from "./TakeFood.vue?vue&type=script&lang=js&"
export * from "./TakeFood.vue?vue&type=script&lang=js&"
import style0 from "./TakeFood.vue?vue&type=style&index=0&id=05faf49d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05faf49d",
  null
  
)

export default component.exports